import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class SidebarVisibilityService {
  private readonly STORAGE_KEY = 'selectedSidebarItems';
  private sidebarSelection$ = new BehaviorSubject<string[]>(this.loadInitial());

  get sidebarItems() {
    return this.sidebarSelection$.asObservable();
  }

  setSidebarItems(items: string[]) {
    localStorage.setItem(this.STORAGE_KEY, JSON.stringify(items));
    this.sidebarSelection$.next(items);
  }

  hasStoredSelection(): boolean {
    return !!localStorage.getItem(this.STORAGE_KEY);
  }

  private loadInitial(): string[] {
    const saved = localStorage.getItem(this.STORAGE_KEY);
    return saved ? JSON.parse(saved).map((s: any) => (s.id ?? s)) : ['strain'];
  }
}
